import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const SelectCurrencyStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonContainer: {
      marginLeft: "10px",
      border: "1px solid #A3A3A3",
      color: "#545454",
      textTransform: "none",
      borderRadius: "10px",
    },
    buttonText: {
      fontSize: "14px",
    },
    paperProps: {
      // desktop styles
      borderRadius: "10px",
      // mobile styles
      [theme.breakpoints.down("md")]: {
        borderRadius: "0px",
        minHeight: "100%",
        minWidth: "100%",
      },
    },
    paperContainer: {
      borderRadius: "10px",
      minHeight: "582px",
      maxWidth: "450px",
      bgcolor: "background.paper",
    },
    title: {
      paddingLeft: "25px",
      fontSize: "16px",
      fontWeight: 600,
    },
    closeContainer: {
      padding: "20px",
    },
    list: {
      "&::-webkit-scrollbar": {
        width: "10px",
      },
      "&::-webkit-scrollbar-track": {
        "-webkit-border-radius": "10px",
        borderRadius: "10px",
      },
      "&::-webkit-scrollbar-thumb": {
        "-webkit-border-radius": "10px",
        borderRadius: "10px",
        background: "#eaeaea",
      },
      width: "100%",
      height: "430px",
      maxWidth: 420,
      bgcolor: "background.paper",
      overflowY: "scroll",
    },
    infiniteScroll: {
      overflowY: "hidden",
      paddingBottom: "20px",
    },
    searchbarContainer: {
      width: "100%",
      height: "100%",
    },
    searchbar: {
      borderRadius: "6px",
      fontWeight: 400,
      fontSize: "1rem",
      color: theme.palette.primary.main,
      cursor: "text",
      width: "100%",
      height: "48px",
      display: "flex",
      justifyContent: "space-between",
      textTransform: "none",
      "& .MuiOutlinedInput-root": {
        height: "100%",
      },
    },
    searchList: {
      maxHeight: "400px",
      overflowY: "auto",
      marginTop: "10px",
      borderRadius: "6px",
      minWidth: "100%",
      height: "auto",
      border: "1px solid #e7e7e7",
      backgroundColor: theme.palette.background.default,
      position: "relative",
      zIndex: 99,
    },
    searchBar: {
      padding: "15px 22px",
    },
    searchbarIcon: {
      marginRight: "12px",
    },
    error: {
      color: "red",
      padding: "0px 10px",
    },
    searchSubtitle: {
      padding: "10px",
      fontSize: "20px",
    },
    listContainer: {
      width: "100%",
      padding: "10px",
    },
    listItem: {
      width: "100%",
      padding: "10px 0px",
      cursor: "pointer",
    },
    listItemRank: {
      maxWidth: "fit-content",
      marginRight: "15px",
    },
    listItemIcon: {
      minWidth: "fit-content",
      marginRight: "10px",
      maxHeight: "30px",
    },
    listName: {
      fontSize: "14px",
    },
  }),
);
